export default {
    label_task:{
        en:"Generated Dates",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Generate",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Crop",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Generate",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_generated_at:{
        en:"Generate Date",
        bn:"প্রিফিক্স"
    },
    label_replica :{
        en:"Replica",
        bn:"কর্মচারী আইডি"
    },
    label_initial_plants :{
        en:"Initial Plants",
        bn:"কর্মচারী আইডি"
    },
}